import { useSuspenseBillingDetails } from '#api/billing.queries.ts';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { ManageBillingCard } from '../manage-billing-card/ManageBillingCard.tsx';
import { SummaryCard } from '../summary-card/SummaryCard.tsx';

export function PaidPlanDetails() {
  const { user } = useAuth();
  const billingDetails = useSuspenseBillingDetails().data.data;

  if (billingDetails.plan !== 'pro') return null;

  return (
    <>
      <SummaryCard billingDetails={billingDetails} />
      {user?.type === 'user' ?
        <ManageBillingCard />
      : null}
    </>
  );
}
